var render = function render(){var _vm=this,_c=_vm._self._c;return _c('meting-js',{attrs:{"server":"tencent","type":"playlist","id":"9192281361","fixed":"true","autoplay":"true","loop":"all","order":"random","auto":"tencent","preload":"auto","list-folded":"true","list-max-height":"500px","lrc-type":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }